import * as Schema from '../schema';
import assembleEntity from '../schema/assembleEntity';
import { createSelector } from 'reselect';

export const selectSoloists = createSelector(
  [state => state.entities, state => state.maps.soloists, (state, id) => id],
  (entities, soloists, id) => {
    if (soloists[id]) {
      return assembleEntity(Schema.PersonList, entities, soloists[id].entities);
    }
    return [];
  }
);

export const selectSoloistsIsLoading = (state, id) =>
  state.maps.soloists[id] && state.maps.soloists[id].loading;

export const selectNextSoloistsCursor = (state, id) => {
  const cursor = state.maps.soloists[id] && state.maps.soloists[id].meta.cursor;
  if (cursor) {
    return cursor.next;
  }
  return null;
};

export const selectPrevSoloistsCursor = (state, id) => {
  const cursor = state.maps.soloists[id] && state.maps.soloists[id].meta.cursor;
  if (cursor) {
    return cursor.prev;
  }
  return null;
};
